
export const getBlogs = (state) => {
    return state.blogs
}
/*
export const addBlog = (state) => {

}*/

export const getBuscat = (state) => (search = '') => {
    if (search.length === 0) return state.blogs
    let blogs = []
    if (search.length > 0) {
        for (let i = 0; i < state.blogs.length; i++) {
            if (state.blogs[i].nombre.toLowerCase().includes(search.toLowerCase())) {
                //console.log(' entrando a nombres')
                blogs.push(state.blogs[i])
            }
        }
        if (blogs.length > 0) {
            //console.log(blogs)
            return blogs
        } else {
            return []
        }
    }
}


export const getBusId = (state) => (id) => {

    if(localStorage.getItem('blog')){
        return  JSON.parse(localStorage.getItem('blog'))
    }
    const blog = state.blogs.find(blog => blog.id == id)
    if (!blog) return
    return { ...blog }
}

export const selectBlog = (state) => {
    const blog = state.blog
    if (!blog) return
    return blog
}



